import styled from 'styled-components';
import { colors } from "../../utils/colors";

export const HelloMessage = styled.h2`
    color: ${colors.BLUE};
    font-family: Courgette, cursive;
    align-self: flex-end;
    margin-right: 100px;
`;

export const MuiButtonWrapper = styled.div`
    display: flex;
    margin-bottom: 30px;
    gap: 30px;

    @media (max-width: 800px) {
        flex-direction: column;
        width: 100%;
    }
`;
